import { render, staticRenderFns } from "./FreightBooking.vue?vue&type=template&id=6a81cd7e&scoped=true&"
import script from "./FreightBooking.vue?vue&type=script&lang=js&"
export * from "./FreightBooking.vue?vue&type=script&lang=js&"
import style0 from "./FreightBooking.vue?vue&type=style&index=0&id=6a81cd7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a81cd7e",
  null
  
)

export default component.exports